import React from "react";

import TitleHelmet from "@/components/TitleHelmet";
import DevicesList from "@/features/devices/components/DevicesList";

import { withAuthenticationRequired } from "@auth0/auth0-react";
import styles from './devices.module.scss';

const Devices: React.FC = () => {
  return (
    <React.Fragment>
      <TitleHelmet title="Devices" />
      <DevicesList />
    </React.Fragment>
  );
};

export default withAuthenticationRequired(Devices);
